
import { DashboardLayout } from "@/components/layouts/DashboardLayout";
import { HRChatInterface } from "@/features/hr-chatbot/components/HRChatInterface";

export default function HRChatbot() {
  return (
    <DashboardLayout>
      <HRChatInterface />
    </DashboardLayout>
  );
}
